import { BalanceProvider } from "./balance";
/**
 * A lazy-loading wrapper around BalanceProvider that defers the actual provider
 * module import until the first fetchBalance() call. This enables code-splitting
 * so heavy SDK dependencies (viem, @wagmi/core, etc.) are not included in the
 * initial bundle.
 *
 * The supportsNetwork() predicate runs synchronously without loading the module.
 * The actual provider is loaded once on first use, then cached for subsequent calls.
 */
export class LazyBalanceProvider extends BalanceProvider {
    constructor(networkPredicate, loader) {
        super();
        this.networkPredicate = networkPredicate;
        this.loader = loader;
        this.instance = null;
        this.loadingPromise = null;
        this.supportsNetwork = (network) => {
            return this.networkPredicate(network);
        };
        this.fetchBalance = async (address, network, options) => {
            const provider = await this.resolve();
            return provider.fetchBalance(address, network, options);
        };
    }
    async resolve() {
        if (this.instance)
            return this.instance;
        if (!this.loadingPromise) {
            this.loadingPromise = this.loader().then(p => {
                this.instance = p;
                this.loadingPromise = null;
                return p;
            });
        }
        return this.loadingPromise;
    }
}
/**
 * A lazy-loading wrapper around GasProvider that defers the actual provider
 * module import until the first getGas() call.
 */
export class LazyGasProvider {
    constructor(networkPredicate, loader) {
        this.networkPredicate = networkPredicate;
        this.loader = loader;
        this.instance = null;
        this.loadingPromise = null;
    }
    supportsNetwork(network) {
        return this.networkPredicate(network);
    }
    async getGas(args) {
        const provider = await this.resolve();
        return provider.getGas(args);
    }
    async resolve() {
        if (this.instance)
            return this.instance;
        if (!this.loadingPromise) {
            this.loadingPromise = this.loader().then(p => {
                this.instance = p;
                this.loadingPromise = null;
                return p;
            });
        }
        return this.loadingPromise;
    }
}
